import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["timer"]

  timerMinutes = null;
  overdueMargin = 10;

  connect() {
    this.overdueMargin = this.element.dataset.overdue || 10;
    this.timerMinutes = this.parseMinutes();
    if (this.timerMinutes == null) {
      return;
    }

    setInterval(() => {
      this.timerMinutes++;
      this.updateTimerDisplay();
      this.markOverdue();
    }, 60_000);
  }

  parseMinutes() {
    const minutes = parseInt(this.timerTarget.dataset.minutes);
    return isNaN(minutes) ? null : minutes;
  }

  updateTimerDisplay() {
    const abs = Math.abs(this.timerMinutes);
    if (abs > 120) {
      const hours = Math.floor(abs / 60);
      this.timerTarget.innerHTML = this.timerMinutes > 0 ? `+${hours}h` : `-${hours}h`;
    } else if (this.timerMinutes > 0) {
      this.timerTarget.innerHTML = `+${this.timerMinutes}m`;
    } else if (this.timerMinutes === 0) {
      this.timerTarget.innerHTML = 'jetzt';
    } else {
      this.timerTarget.innerHTML = `in ${abs}m`;
    }
  }

  markOverdue() {
    if (this.timerMinutes > this.overdueMargin && this.element.dataset.status !== "ready") {
      this.element.classList.add("card-overdue");
    }
  }

  toggle() {
    this.element.classList.toggle("folded");
  }

  showContact({ params: { name, email, phone } }) {
    alert(`${name}\nEmail: ${email}\nTelefonnummer: ${phone}`);
  }

  openMap({ params: { address } }) {
    window.open(`https://www.google.de/maps/search/${encodeURIComponent(address)}/`, 'terminalMapsWindow');
  }

  payModal(event) {
    const id = event.target.dataset.id;
    if (!id) {
      event.preventDefault();
      return;
    }
    const frame = document.getElementById("modal-frame");
    frame.src = '';
    frame.src = "/terminal/orders/" + id;
  }

  shipmentModal(event) {
    const id = event.target.dataset.id;
    if (!id) {
      event.preventDefault();
      return;
    }
    const frame = document.getElementById("modal-frame");
    frame.src = '';
    frame.src = "/terminal/orders/" + id + "/shipments";
  }
}
